import queryProductsSearchServiceV3 from "@faire/web-api/api/v3/search/products/post";
import { getQueryKey_escape_hatch as getQueryKeySearchProductsV3 } from "@faire/web-api/api/v3/search/products/post-hooks";
import { useQuery } from "@tanstack/react-query";

import { useExplorePageProductsRequest } from "@faire/retailer/views/explore-page/__internal__/useExplorePageProductsRequestKey";

export const useExplorePageProductsQuery = () => {
  const request = useExplorePageProductsRequest();
  const {
    isPending: isSearchPending,
    isError: isSearchError,
    data,
    dataUpdatedAt: searchDataUpdatedAt,
  } = useQuery({
    queryKey: getQueryKeySearchProductsV3(request),
    queryFn: ({ signal }) =>
      queryProductsSearchServiceV3(request, {
        signal,
      }),
    staleTime: 1000 * 60 * 5,
  });

  return {
    isSearchPending,
    isSearchError,
    searchDataUpdatedAt,
    relatedSearchTerms: data?.related_search_terms ?? [],
    totalPrimaryResults: data?.pagination_data?.total_results ?? 0,
    brandMap: data?.brands_by_token ?? {},
    brands: data?.brand_tiles_related_to_search ?? [],
    products: data?.product_tiles ?? [],
    requestId: data?.request_id,
    allRetrievalQueries: data?.retrieval_queries ?? [],
  };
};
